var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUploadSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64645 2.14645C7.84171 1.95118 8.15829 1.95118 8.35355 2.14645L10.9786 4.77145C11.1738 4.96671 11.1738 5.28329 10.9786 5.47855C10.7833 5.67382 10.4667 5.67382 10.2714 5.47855L8 3.20711L5.72855 5.47855C5.53329 5.67382 5.21671 5.67382 5.02145 5.47855C4.82618 5.28329 4.82618 4.96671 5.02145 4.77145L7.64645 2.14645Z",
    fill: "url(#paint0_linear_318_11869)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.27614 2 8.5 2.22386 8.5 2.5V9.5C8.5 9.77614 8.27614 10 8 10C7.72386 10 7.5 9.77614 7.5 9.5V2.5C7.5 2.22386 7.72386 2 8 2Z",
    fill: "url(#paint1_linear_318_11869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9C2.77614 9 3 9.22386 3 9.5V13H13V9.5C13 9.22386 13.2239 9 13.5 9C13.7761 9 14 9.22386 14 9.5V13C14 13.2652 13.8946 13.5196 13.7071 13.7071C13.5196 13.8946 13.2652 14 13 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V9.5C2 9.22386 2.22386 9 2.5 9Z",
    fill: "url(#paint2_linear_318_11869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_11869",
    x1: 4.95607,
    y1: 2.30476,
    x2: 11.123,
    y2: 2.97255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_11869",
    x1: 7.51297,
    y1: 2.67257,
    x2: 8.51119,
    y2: 2.6804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_11869",
    x1: 2.15566,
    y1: 9.42035,
    x2: 13.8689,
    y2: 11.1859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002CF1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadSimple);
export default __webpack_public_path__ + "static/media/Ic_UploadSimple.d05cd1ff3c40deff0c128e4c956a1623.svg";
export { ForwardRef as ReactComponent };